import axios from "axios";
import { servicePath } from "../../utility/data";

export const getGraphServices = async (id, accessToken) => {
  try {
    const response = await axios.get(
      `${servicePath}/company/get-visuals?company_id=${id}`,
      {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
      }
    );

    return response;
  } catch (error) {
    console.error("Error:", error);
    throw error;
  }
};

export const getMediaService = async (id, accessToken) => {
  try {
    const response = await axios.get(
      `${servicePath}/company/get-medias?company_id=${id}`,
      {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
      }
    );

    return response;
  } catch (error) {
    console.error("Error:", error);
    throw error;
  }
};

export const getStatsService = async (id, accessToken) => {
  try {
    const response = await axios.get(
      `${servicePath}/company/get-stats?company_id=${id}`,
      {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
      }
    );

    return response;
  } catch (error) {
    console.error("Error:", error);
    throw error;
  }
};
